<div class="collector-selector-modal">
	<div mat-dialog-title class="dialog-header">
		<h2>Select Collector ({{ data.agency.Account_Name }})</h2>
		<button mat-icon-button (click)="onCancel()" class="close-button">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="dialog-content">

		<!-- Search Bar -->
		<div class="search-bar">
			<mat-form-field appearance="outline" class="search-field">
				<mat-label>Search collector</mat-label>
				<input
					matInput
					(keyup)="applyFilter($event)"
					placeholder="Search by name, email, or phone"
				/>
				<mat-icon matPrefix>search</mat-icon>
			</mat-form-field>

			<button
				mat-raised-button
				color="primary"
				(click)="createNewCollector()"
				[disabled]="true"
				class="create-button"
			>
				<mat-icon>add</mat-icon>
				Create New Collector
			</button>
		</div>

		<!-- Loading State -->
		<div *ngIf="loading" class="loading-state">
			<p>Loading collectors...</p>
		</div>

		<!-- Collectors Table -->
		<div *ngIf="!loading" class="table-container">
			<table
				mat-table
				[dataSource]="dataSource"
				class="flat-table"
			>
				<!-- Radio Button Column -->
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let collector">
						<mat-radio-button
							[checked]="selectedCollector?.id === collector.id"
							[value]="collector.id"
							(keyup)="selectCollector(collector);"
						></mat-radio-button>
					</td>
				</ng-container>

				<!-- Name Column -->
				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef>Name</th>
					<td mat-cell *matCellDef="let collector">
						{{ collector.name || '-' }}
					</td>
				</ng-container>

				<!-- Phone Column -->
				<ng-container matColumnDef="phone">
					<th mat-header-cell *matHeaderCellDef>Phone</th>
					<td mat-cell *matCellDef="let collector">
						{{ collector.Phone || '-' }}
					</td>
				</ng-container>

				<!-- Extension Column -->
				<ng-container matColumnDef="extension">
					<th mat-header-cell *matHeaderCellDef>Extension</th>
					<td mat-cell *matCellDef="let collector">
						{{ collector.Extension || '-' }}
					</td>
				</ng-container>

				<!-- Email Column -->
				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef>Email</th>
					<td mat-cell *matCellDef="let collector">
						{{ collector.Email || '-' }}
					</td>
				</ng-container>

				<!-- Agent Column -->
				<ng-container matColumnDef="agent">
					<th mat-header-cell *matHeaderCellDef>Agent</th>
					<td mat-cell *matCellDef="let collector">
						{{ collector.Agent || '-' }}
					</td>
				</ng-container>

				<!-- Owner Column -->
				<ng-container matColumnDef="owner">
					<th mat-header-cell *matHeaderCellDef>Owner</th>
					<td mat-cell *matCellDef="let collector">
						{{ collector.Owner?.name || '-' }}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(click)="selectCollector(row)"
					class="clickable-row"
				></tr>
			</table>

			<!-- No Results -->
			<div *ngIf="dataSource.filteredData.length === 0" class="no-results">
				<mat-icon>info</mat-icon>
				<p>No collectors found</p>
			</div>
		</div>
	</mat-dialog-content>
